// Composed skeleton that mimics a list row: optional leading shape
// (icon / avatar) + 1-2 text lines + optional trailing shape (chevron).
// Use in place of a centered ActivityIndicator while a list is loading.
// Gives the user a layout-preserving placeholder they can recognize.
//
// Example:
//   {loading
//     ? <View>{Array.from({ length: 4 }, (_, i) => (
//         <ListRowSkeleton key={i} showLeading showSubtitle />
//       ))}</View>
//     : list.map(item => <Row data={item} />)}
import { View } from "react-native";
import { MoonSkeleton } from "./MoonSkeleton";
import { spacing } from "../theme/tokens";

type Props = {
  /** Render a leading circular shape (avatar / 3D icon placeholder). */
  showLeading?: boolean;
  /** Render a leading rounded-square shape (icon-in-tile placeholder). */
  showLeadingSquare?: boolean;
  /** Render the second text line under the title. */
  showSubtitle?: boolean;
  /** Render a small trailing block (chevron / status pill placeholder). */
  showTrailing?: boolean;
};

export function ListRowSkeleton({
  showLeading,
  showLeadingSquare,
  showSubtitle,
  showTrailing,
}: Props) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: spacing.md,
        paddingHorizontal: spacing.md,
        gap: spacing.sm + 2,
      }}
    >
      {showLeading ? (
        <MoonSkeleton width={40} height={40} circle />
      ) : showLeadingSquare ? (
        <MoonSkeleton width={40} height={40} radius={10} />
      ) : null}

      <View style={{ flex: 1, gap: 6 }}>
        <MoonSkeleton width="55%" height={14} />
        {showSubtitle && <MoonSkeleton width="80%" height={11} />}
      </View>

      {showTrailing && <MoonSkeleton width={16} height={16} />}
    </View>
  );
}
